// checkout/utils/addBackForwardListener.ts

/**
 * Adds a listener for browser back and forward navigation events.
 *
 * When the user navigates using the browser's back or forward buttons,
 * and the current URL path includes `/checkout` but does **not** include
 * `/review`, the page is reloaded to ensure the application
 * state stays in sync with the URL.
 */
export function addBackForwardListener() {
	window.addEventListener('popstate', () => {
		const path = window.location.pathname;
		if (path.includes('/checkout') && !path.includes('/review')) {
			window.location.reload();
		}
	});
}
